// extracted by css-extract-rspack-plugin
export default {"clickable":"LsOMso","spacer":"YrKzO2","app":"b9lGA_"};